import { useCallback } from "react";

import { GqlClient, GqlProject } from "~/__generated__";
import useCreateClientUrl from "~/modules/client/hooks/useCreateClientUrl";

import useCurrentProject from "./useCurrentProject";

export default function useCreateProjectUrl(): (
    to?: string,
    options?: { project?: Pick<GqlProject, "slug">; client?: GqlClient; relative?: boolean },
) => string {
    const createClientUrl = useCreateClientUrl();
    const { data: currentProject } = useCurrentProject();

    return useCallback(
        (to = "", options?: { project?: Pick<GqlProject, "slug">; client?: GqlClient; relative?: boolean }) => {
            const slug = options?.project ? options.project.slug : currentProject?.project.slug;
            return createClientUrl(`p/${slug}/${to}`, options);
        },
        [createClientUrl, currentProject],
    );
}
